"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestStatus = void 0;
var BotTestStatus;
(function (BotTestStatus) {
    BotTestStatus["STANDBY"] = "standby";
    BotTestStatus["PENDING"] = "pending";
    BotTestStatus["RUNNING"] = "running";
    BotTestStatus["COMPLETED"] = "completed";
    BotTestStatus["FAILED"] = "failed";
})(BotTestStatus || (exports.BotTestStatus = BotTestStatus = {}));
;
